import { render, staticRenderFns } from "./DateNavigationButtonGoToToday.vue?vue&type=template&id=4ef649a0&scoped=true&"
import script from "./DateNavigationButtonGoToToday.vue?vue&type=script&lang=js&"
export * from "./DateNavigationButtonGoToToday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef649a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ef649a0')) {
      api.createRecord('4ef649a0', component.options)
    } else {
      api.reload('4ef649a0', component.options)
    }
    module.hot.accept("./DateNavigationButtonGoToToday.vue?vue&type=template&id=4ef649a0&scoped=true&", function () {
      api.rerender('4ef649a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/generic/DateNavigationButtonGoToToday.vue"
export default component.exports